import { __rest } from "tslib";
import * as React from "react";
function SvgAdd(_a) {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2048 2048", width: "1em", height: "1em", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M1664 896v128h-640v640H896v-640H256V896h640V256h128v640h640z" })));
}
export default SvgAdd;
